<!--
 * @Description: 关联文档(文件)
-->
<template>
  <div>
    <el-row :gutter="20" class="w-full">
      <el-col :span="12">
        <div class="header-content mb-20px" v-if="fileList && fileList.length > 0">
          <!-- <el-button @click="uploadAll" size="mini">
                    {{ `${$t('updateAll')}` }}
                  </el-button>
                  <el-button @click="uploadChoose" size="mini">{{
                    `${$t('updateSelected')}`
                  }}</el-button> -->
          <el-button type="primary" @click="setDefaultFile" size="mini">{{
            $t('setAsMasterFile')
          }}</el-button>
        </div>
        <div>
          <el-table
            :data="fileList"
            style="width: 100%"
            ref="table"
            :highlight-current-row="true"
            @row-click="clickIncidenceTable"
            @selection-change="selectFile"
            border
            height="200px"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column :label="`${$t('fileName')}`" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="flex w-full">
                  <div class="flex-1 truncate">{{ scope.row.fileNameOrigin }}</div>
                  <el-tooltip
                    :content="`${$t('defaultFile')}`"
                    :open-delay="1000"
                    v-if="scope.row.isDefault"
                    class="ml-10px"
                  >
                    <i class="iconfont icon-bg-collection"></i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="100">
              <template slot-scope="scope">
                <el-popover placement="top" v-model="scope.row.isDelete1">
                  <p class="mb-10px">{{ $t('delConfirm') }}</p>
                  <div class="tr">
                    <el-button size="mini" type="text" @click="scope.row.isDelete1 = false">{{
                      `${$t('Cancel')}`
                    }}</el-button>
                    <el-button type="primary" size="mini" @click="confirmDelete">{{
                      `${$t('Sure')}`
                    }}</el-button>
                  </div>
                  <el-button
                    type="text"
                    style="color: #333; border: 1px solid #ccc"
                    @click.stop="deleteRightList(scope.$index)"
                    slot="reference"
                    :title="`${$t('delete')}`"
                    size="mini"
                    >{{ $t('delete') }}</el-button
                  >
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-upload
          drag
          action="https://xx.yy.zz"
          :show-file-list="false"
          :before-upload="getFileContent"
          :http-request="httpRequest"
          :multiple="false"
          class="mt-10px uploadDoc w-full"
        >
          <i style="font-size: 67px" class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ $t('onlyOneFileCanBeUploadedAtATime') }},{{ $t('or') }}
            <em>{{ $t('clickUpload') }}</em>
          </div>
        </el-upload> -->
        <!-- 分片上传 -->
        <chunkUploadFiles
          class="w-full"
          :initFiles="initFiles"
          :multipleable="multipleable"
          :uploadParams="uploadParams"
          @uploadSuccess="uploadSuccess"
        ></chunkUploadFiles>
      </el-col>
      <el-col :span="12">
        <div class="mb-10px">
          <el-input
            size="small"
            clearable
            @keyup.enter.native="searchHasAssociatedTableData()"
            :placeholder="`${$t('enterTitle')}`"
            v-model="hasRelationKeyWords"
            style="width: 48%"
            class="mr-10px"
          ></el-input>
          <el-button type="primary" @click="searchHasAssociatedTableData()">{{
            $t('search')
          }}</el-button>
          <el-button class="!ml-10px" type="primary" @click="addIncidenceDoc()">{{
            $t('AddAssociatedDocuments')
          }}</el-button>
        </div>
        <el-table
          :data="hasRelationTableData"
          class="w-full"
          height="410px"
          highlight-current-row
          border
        >
          <el-table-column
            prop="fileName"
            :label="`${$t('fileName')}`"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="documentName"
            width="150"
            :label="`${$t('documentName')}`"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="documentRevision"
            :label="`${$t('documentVersion')}`"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('operate')}`" width="100">
            <template slot-scope="scope">
              <el-popover placement="top" v-model="scope.row.isDelete">
                <p class="mb-10px">{{ `${$t('WhetherToDisassociate')}?` }}</p>
                <div class="tr">
                  <el-button size="mini" type="text" @click="scope.row.isDelete = false">{{
                    `${$t('Cancel')}?`
                  }}</el-button>
                  <el-button type="primary" size="mini" @click="relieveRelation(scope.row)">{{
                    `${$t('Sure')}`
                  }}</el-button>
                </div>
                <el-button
                  style="color: #333; border: 1px solid #ccc"
                  type="text"
                  slot="reference"
                  :title="`${$t('Disassociate')}`"
                  size="mini"
                  >{{ $t('DisRelation') }}</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="tc pt-10px">
          <el-pagination
            background
            @size-change="searchHasAssociatedTableData()"
            @current-change="findHasAssociatedTableData()"
            :current-page.sync="incidenceRelationPage.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size="hasRelationPage.pageSize"
            layout="->, total, sizes, prev, pager, next"
            :total="hasRelationPage.pageTotal"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 新增关联文档start -->
    <el-dialog
      width="1100px"
      :append-to-body="true"
      :title="`${$t('ManualAssociation')}`"
      :visible.sync="incidenceRelationVisible"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-row :gutter="20" class="h-480px">
        <!-- 实体树 -->
        <el-col :span="8" class="h-full">
          <div class="w-full h-full border-1px px-20px py-10px">
            <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px leading-28px">
              目录树
            </div>
            <div class="flex mt-10px">
              <el-input
                size="small"
                v-model.trim="treeKeyWord"
                :placeholder="`${$t('搜索名称')}`"
                @keyup.enter.native="getCurrentTree"
                clearable
              ></el-input>
              <el-button type="primary" class="ml-10px" @click="getCurrentTree">{{
                $t('search')
              }}</el-button>
            </div>
            <div class="tree h-[calc(100%-80px)] mt-10px overflow-y-auto">
              <el-tree
                id="documentMenuTree"
                ref="documentMenuTree"
                highlight-current
                :data="currentTree"
                @node-click="handleDocNodeClick"
                @node-expand="nodeExpand"
                @node-collapse="nodeCollapse"
                :props="defaultTreeProps"
                :default-expanded-keys="initExpandList"
                v-if="treeStandBy"
                node-key="id"
                class="fz-14"
                :lazy="!isExpandAll"
                :default-expand-all="isExpandAll"
                :load="lazyNode"
              >
                <span slot-scope="{ node }" class="w-full">
                  <div class="d-flex flex-align-center flex">
                    <el-tooltip :content="node.label" :open-delay="1000" placement="top">
                      <p
                        class="flex-1 ell truncate"
                        style="width: 80px; line-height: 25px"
                        :class="{
                          blueText: treeKeyWord
                            ? node.label.indexOf(treeKeyWord) !== -1 ||
                              node.label.indexOf(treeKeyWord.toLowerCase()) !== -1
                            : false,
                        }"
                      >
                        {{ node.label }}
                      </p>
                    </el-tooltip>
                  </div>
                </span>
              </el-tree>
            </div>
          </div>
        </el-col>
        <!-- 文件列表 -->
        <el-col :span="16" class="h-full">
          <el-row :gutter="10" class="mb-10px">
            <el-col :span="18">
              <el-input
                v-model="incidenceRelationDocKeyWords"
                placeholder="输入文件名或文档名称"
                clearable
              />
            </el-col>
            <el-col :span="6" class="pull-right">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="refreshIncidenceTable()"
                >{{ `${$t('search')}` }}</el-button
              >
            </el-col>
          </el-row>
          <el-table
            class="h-[calc(100%-80px)] overflow-y-auto"
            :data="incidenceTableData"
            @selection-change="handleSelectionChange"
            ref="multipleTable"
            v-loading="incidenceTableLoading"
            border
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column :label="`${$t('fileName')}`" prop="fileName"></el-table-column>
            <el-table-column :label="`${$t('documentName')}`" prop="documentName"></el-table-column>
            <el-table-column
              prop="documentRevision"
              :label="`${$t('documentVersion')}`"
              width="150"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="refreshIncidenceTable"
            @current-change="searchNotAssociatedDoc"
            :current-page.sync="incidenceRelationPage.pageNo"
            :page-sizes="$pageSizeAll"
            :page-size.sync="incidenceRelationPage.pageSize"
            layout="->, total, sizes, prev, pager, next"
            :total="incidenceRelationPage.pageTotal"
            class="mt-10px"
          ></el-pagination>
        </el-col>
      </el-row>

      <div slot="footer" class="t-r">
        <el-button size="small" @click="incidenceRelationVisible = false">{{
          `${$t('Cancel')}`
        }}</el-button>
        <el-button type="primary" size="small" @click="saveIncidenceRelation()">{{
          `${$t('save')}`
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import ApiMixinTags from '@/assets/js/api/tags'
import ApiMixinTagCategory from '@/assets/js/api/tagCategory'
import ApiMixinDocument from '@/assets/js/api/documents'
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import DocumentService from '@/services/DocumentService'
import documentManagementService from '@/services/documentManagement'
import { deleteFileList } from '@/api/article'
import chunkUploadFiles from './chunkUploadFiles'

export default {
  name: 'associatedDocuments',
  mixins: [
    ApiMixinTags,
    ApiMixinTagCategory,
    ApiMixinDocument,
    FnMixins,
    ApiMixinCable,
    ApiMixinDocumentList,
  ],
  props: {
    associatedDocumentsProps: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    chunkUploadFiles,
  },
  data() {
    return {
      fileList: [] /* 存放关联关系中表格的数据 */,
      currentIncidenceDocRow: null,
      fileId: [], // 关联关系-文件id
      hasRelationKeyWords: '',
      hasRelationTableData: [], // 已经关联的table
      hasRelationPage: {
        // 已经关联的page
        pageNo: 1,
        pageSize: 999,
        pageTotal: 0,
      },
      incidenceRelationPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      page: {
        // 关联关系的
        pageNo: 1,
        pageSize: 15,
        count: 0,
      },
      file: {}, // 关联关系-上传的文件
      incidenceRelationVisible: false, // 关联关系
      incidenceTableData: [], // 手动关联文件table
      relationTotalSelection: [], // 关联文档所有选中的
      incidenceTableLoading: false,
      incidenceRelationDocKeyWords: '', // 手动关联搜索关键字
      index: [], // 文件列表的下标
      treeStandBy: true, // 目录树显示与否
      currentTree: [], // 当前目录树数据
      treeKeyWord: '', // 目录树搜索关键字
      isExpandAll: false, // 是否展开全部
      defaultTreeProps: {
        children: 'childrens',
        label: 'name',
      },
      initExpandList: [],
      expandList: [], // 当前目录树展开项的集合
      selectedfolderId: '', // 当前选中的目录树节点id
      initFiles: [],
      multipleable: true,
      uploadParams: {
        standardId: '',
        documentId: '',
      },
    }
  },
  watch: {
    associatedDocumentsProps: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.uploadParams.standardId = val.standardId
          this.uploadParams.documentId = val.rowData.id
        }
      },
    },
    'associatedDocumentsProps.rowData': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.getFileList1()
        }
      },
    },
    incidenceRelationVisible(bol) {
      // 控制新增关联文件弹窗
      if (!bol) {
        this.incidenceRelationPage.pageNo = 1
        this.incidenceTableData = []
        this.relationTotalSelection = []
        this.incidenceRelationDocKeyWords = ''
      }
    },
  },
  created() {},
  methods: {
    // 搜索获取目录树数据
    async getCurrentTree() {
      if (this.treeKeyWord) {
        this.treeStandBy = false
        this.$nextTick(async () => {
          this.isExpandAll = true
          this.treeStandBy = true
          this.currentTree = await this.loadNode(false)
        })
      } else {
        this.treeStandBy = false
        setTimeout(async () => {
          this.isExpandAll = false
          this.treeStandBy = true
          this.currentTree = await this.loadNode(true)
        }, 500)
      }
    },
    // 加载目录树数据
    async loadNode(isRoot, nodeId) {
      const res = await documentManagementService.getDocumentTree({
        standardId: this.associatedDocumentsProps.standardId,
        filter: this.treeKeyWord,
        isRoot, // 是否查询根节点，true：查询根节点，false：查询子节点
        nodeId, // 节点id
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 懒加载子节点
    async lazyNode(node, resolve) {
      this.isExpandAll = false
      let res = []
      if (node.data.id) {
        res = await this.loadNode(false, node.data.id)
      }
      resolve(res)
    },
    // 点击左侧目录树节点，获取右侧详情
    async handleDocNodeClick(data) {
      this.selectedfolderId = data.id
      this.refreshIncidenceTable()
    },
    nodeExpand(data) {
      this.expandList.push(data.folderId)
    },
    nodeCollapse(data) {
      this.expandList = _.filter(this.expandList, (i) => {
        return i !== data.folderId
      })
    },
    clickIncidenceTable(row) {
      // 单击关联文档table
      this.currentIncidenceDocRow = row // 当前关联文档赋值
      this.searchHasAssociatedTableData()
    },
    async searchHasAssociatedTableData() {
      // 搜索已关联数据
      this.hasRelationPage.pageNo = 1
      this.findHasAssociatedTableData()
    },
    // 获取当前选中文件的id
    selectFile(val) {
      const ret = []
      val.forEach((item) => {
        return ret.push(item.fileIdOrigin)
      })
      this.fileId = ret
    },
    getFileContent(file) {
      this.file = file
    },
    // 自定义上传文件
    async httpRequest(params) {
      const form = new FormData()
      form.append('file', params.file)
      form.append('documentId', this.associatedDocumentsProps.rowData.id)
      form.append('standardId', this.associatedDocumentsProps.standardId)
      const res = await DocumentService.uploadReleFile(form)
      if (res && res.code === 0) {
        this.$message.success(res.msg)
        this.getFileList1() // 获取文件列表
      } else {
        this.$message.warning(res.msg)
      }
    },
    uploadSuccess(val) {
      if (val) {
        this.getFileList1()
      }
    },
    async saveIncidenceRelation() {
      // 保存关联关系
      if (_.isEmpty(this.relationTotalSelection)) {
        this.$message.warning(this.$t('PleaseSelectAnAssociatedFile'))
        return
      }
      const res = await documentManagementService.addFileJoinfile({
        sourceTagId: this.currentIncidenceDocRow.fileIdOrigin,
        targetTagId: _.map(this.relationTotalSelection, (item) => {
          return item.fileId
        }),
      })
      if (res && res.code === 0) {
        this.$message.success(this.$t('TheAssociatedFileIsSuccessful'))
        this.incidenceRelationVisible = false
        this.searchHasAssociatedTableData()
      } else {
        this.$message.error(res.message)
      }
    },
    async findHasAssociatedTableData() {
      // 查询已关联数据
      const res = await documentManagementService.getFileReleFileList({
        standardId: this.associatedDocumentsProps.standardId,
        sourceTagId: this.currentIncidenceDocRow.fileIdOrigin,
        // jointype: 0, // 已关联
        keywords: this.hasRelationKeyWords,
        skipCount: this.hasRelationPage.pageNo - 1,
        maxResultCount: this.hasRelationPage.pageSize,
        Sorting: '',
      })
      if (res && res.code === 0) {
        this.hasRelationTableData = res.data
        this.hasRelationPage.pageTotal = res.totalCount
      }
    },
    async relieveRelation(row) {
      // 解除关联关系
      const res = await documentManagementService.fileJoinfile(row.id)
      if (res && res.code === 0) {
        this.$message.success(this.$t('DisassociationSucceeded'))
        this.searchHasAssociatedTableData()
      } else {
        this.$message.error(res.message)
      }
    },
    async addIncidenceDoc() {
      // 添加关联文档
      if (!this.currentIncidenceDocRow) {
        this.$message.warning(this.$t('PleaseSelectADocumentToLink'))
        return
      }
      this.incidenceRelationVisible = true
      this.selectedfolderId = ''
      this.getCurrentTree()
      this.searchNotAssociatedDoc()
    },
    async searchNotAssociatedDoc() {
      // 搜索未关联的文档
      this.incidenceTableLoading = true
      const res = await documentManagementService.getFileOkReleFileList({
        StandardId: this.associatedDocumentsProps.standardId,
        fileId: this.currentIncidenceDocRow.fileIdOrigin,
        keywords: this.incidenceRelationDocKeyWords,
        skipCount: this.incidenceRelationPage.pageNo - 1,
        maxResultCount: this.incidenceRelationPage.pageSize,
        folderId: this.selectedfolderId,
      })
      this.incidenceTableLoading = false
      if (res && res.code === 0) {
        this.incidenceTableData = res.data
        this.incidenceRelationPage.pageTotal = res.totalCount
      }
    },
    /* 获取关联关系左侧tab */
    async getFileList1() {
      const res = await documentManagementService.getFileList({
        id: this.associatedDocumentsProps.rowData.id,
        standardId: this.associatedDocumentsProps.standardId,
      })
      if (res.length > 0) {
        res.forEach((item) => {
          item.isDelete = false // isRemove
          item.isDelete1 = false // isRemove
        })
        this.fileList = res
        // 设置默认选中第一行
        this.$refs.table.setCurrentRow(this.fileList[0])
        this.clickIncidenceTable(this.fileList[0])
      } else {
        this.fileList = []
      }
    },
    handleSelectionChange(val) {
      _.forEach(this.relationTotalSelection, (item) => {
        if (_.find(this.incidenceTableData, ['id', item.id])) {
          this.relationTotalSelection = _.difference(this.relationTotalSelection, [item])
        }
      })
      this.relationTotalSelection = [...this.relationTotalSelection, ...val]
    },
    refreshIncidenceTable() {
      this.incidenceRelationPage.pageNo = 1
      this.searchNotAssociatedDoc()
    },
    // 设置默认文件
    async setDefaultFile() {
      if (this.fileId.length < 1) {
        this.$message.warning(`${this.$t('PleaseCheckTheFileAndThenSetTheDefaultFile')}`)
      } else if (this.fileId.length > 1) {
        this.$message.warning(`${this.$t('OnlyOneDefaultFileCanBeSet')}!`)
      } else {
        const res = await this.apiDocumentList({
          method: 'setDefaultFile',
          params: {
            fileId: this.fileId[0],
            id: this.associatedDocumentsProps.rowData.id,
            standardId: this.associatedDocumentsProps.standardId,
          },
        })
        if (res && res.code === 0) {
          this.$message.success(`${this.$t('SetDefaultFileSuccessfully')}!`)
          this.getFileList1()
        }
      }
    },
    // 关联关系左侧tab中点击确认删除
    confirmDelete() {
      const id = this.fileList[this.index].id
      const fileName = this.fileList[this.index].fileName
      const $lis = $('.filelist').find('li')
      for (let i = 0; i < $lis.length; i += 1) {
        if (
          $lis
            .eq(i)
            .find('.title')
            .html() === fileName
        ) {
          // 通过判断文件名称相同删除文件区域中相对应的文件
          $lis
            .eq(i)
            .off()
            .find('.file-panel')
            .off()
            .end()
            .remove()
        }
      }
      this.deleteFileList1(id, this.index)
    },
    // 关联关系左侧的tab中点击删除图标
    deleteRightList(index) {
      if (this.isShowLeft === index) {
        this.isShowLeft = -1
      } else {
        this.isShowLeft = index
      }
      this.index = index
    },
    // 删除关联关系tab列表的请求
    deleteFileList1(id) {
      // const data = [id]
      const data = { documentFileId: id }
      this.fileId = id
      deleteFileList(data)
        .then((res) => {
          if (res.data.code === 0) {
            // this.getDocumentTags1()
            // 删除成功后将fileId置空
            this.fileId = []
            this.tagDataByFile()
            this.$message({
              title: this.$t('success'),
              message: this.$t('successfullyDeleted'),
              type: 'success',
              duration: 2000,
            })
            this.isShowLeft = -1
            this.getFileList1()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取关联关系右侧的文件内容
    async tagDataByFile() {
      const data = await this.tagInfoByFile()
      _(data.data).forEach((item) => {
        item.isDelete = false
      })
      this.fileData = data.data
      // _.forEach(this.fileData, (i) => {
      //   if (i.nameSpace) {
      //     i.name = `${i.code}[${i.nameSpace}]`
      //   } else {
      //     i.name = `${i.code}`
      //   }
      // })
      // if (data.page) {
      this.page.count = data.totalCount
      // } else {
      //   this.page.count = 0
      // }
    },
    // 获取关联关系右侧的表单数据
    async tagInfoByFile() {
      if (this.fileId) {
        const res = await this.apiDocumentList({
          method: 'tagInfoByFile',
          params: {
            DocumentFileId: this.fileId,
            SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
            MaxResultCount: this.page.pageSize,
            Keywords: this.tagKeywords || ' ',
          },
          extra: { errorMsg: false },
        })
        if (res && res.code === 0) {
          return res
        }
        return {}
      }
      return {}
    },
  },
}
</script>

<style ref="stylesheet/scss" type="text/scss" lang="scss" scoped>

/deep/.el-upload {
  width: 100% !important;
}
.uploadDoc /deep/.el-upload-dragger {
  width: 100% !important;
  height: 230px !important;
}

</style>
